import { Text } from '@cinch-labs/design-system'
import styles from './flexbox-two-columns.module.css'
import classNames from 'classnames'
export interface FlexboxTwoColumnsProps {
  classNamings?: {
    container?: string
    row?: string
    column?: string
  }
  rows: {
    columns: (string | JSX.Element)[]
    classNames?: string[]
    reverseColumnOrderForMobile: boolean
  }[]
}

export function FlexboxTwoColumns({
  classNamings,
  rows,
}: FlexboxTwoColumnsProps) {
  return (
    <div className={classNames(classNamings?.container)}>
      {rows.map((row, i) => (
        <div
          key={'flexbox-row-' + i}
          className={classNames(styles.row, classNamings?.row, {
            [styles.reverseColumnOrder]: row.reverseColumnOrderForMobile,
          })}
        >
          {row.columns.map((column, i) => (
            <div
              key={'flexbox-column-' + i}
              className={classNames(styles.column, classNamings?.column)}
            >
              {typeof column === 'string' ? <Text>{column}</Text> : column}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
